/* @flow strict */

import * as React from 'react';
import DBBody from './body';
import RangeCalendar from '/client/src/components/calendar/range';
import { GET } from '/client/src/api/';
import { customerDatabaseExport } from '/client/src/utils/export';
import moment from 'moment';
import NavbarTitleBackAction from '/client/src/components/topNavbar/backAction';

import './styles.scss';

type PropsType = {};

const DBPage = ({ }: PropsType): React.Element<'div'> => {
  const [startTime, setStartTime] = React.useState(
    moment().subtract(11, 'month')
  );
  const [endTime, setEndTime] = React.useState(moment());
  const [pending, setPending] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [skipCount, setSkipCount] = React.useState(0);
  const [totalRows, setTotalRows] = React.useState(0);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [maxResultCount, setMaxResultCount] = React.useState(100);
  const [search, setSearch] = React.useState('');
  const [searchString, setSearchString] = React.useState('');
  const [sortString, setSortString] = React.useState('');

  const fetchData = async () => {
    setPending(true);
    try {
      const { result } = await GET(
        `/api/v1/1/customers?${search ? `email_address=${search}&` : ''}last_participate_begin_timestamp_utc=${startTime.unix()}&last_participate_end_timestamp_utc=${endTime.unix()}&skip_count=${skipCount}&max_result_count=${maxResultCount}${sortString ? `&sorting=${sortString}` : ''}`
      );

      setRows(result.items);
      setTotalRows(result.total_count);
      setPending(false);
    } catch (e) {
      console.log(e);
      console.error('Cant get reminders');
      setPending(false);
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setSkipCount(page * maxResultCount - maxResultCount);
  };

  React.useEffect(() => {
    fetchData();
  }, [startTime, endTime, search, skipCount, maxResultCount, sortString]);

  return (
    <div className="sparxo-router-content">
      <NavbarTitleBackAction />
      <div className="sparxo-page-container">
        <div className="event-list">
          <div className="panel panel-default DBPage">
            <div
              className="navbar navbar-default navbar-page-toolbar customers-navbar"
              style={{ marginBottom: 0 }}
            >
              <div className="navbar-header">
                <button
                  type="button"
                  className="navbar-toggle collapsed"
                  data-toggle="collapse"
                  data-target="#navbar-collapse-customer-database"
                  aria-expanded="false"
                >
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                </button>
              </div>

              <div
                className="collapse navbar-collapse"
                id="navbar-collapse-customer-database"
              >
                <ul className="nav navbar-nav">
                  <li>
                    <a
                      href="#"
                      style={{ padding: '5px 20px' }}
                      onClick={(e: any): any => {
                        e.preventDefault();

                        customerDatabaseExport();
                      }}
                    >
                      <i className="icon icon-export" />
                      <span>Export</span>
                    </a>
                  </li>
                </ul>

                <div className="navbar-right" style={{ marginRight: 0 }}>
                  <div
                    className="collapse navbar-collapse"
                    id="navbar-collapse-customer-database1"
                    style={{ float: 'left' }}
                  >
                    <div
                      className="pull-right chart1-datetime chart1-datetime-gary"
                      style={{ marginTop: '5px' }}
                    >
                      <RangeCalendar
                        end={endTime.format()}
                        start={startTime.format()}
                        startCb={setStartTime}
                        endCb={setEndTime}
                      />
                    </div>
                  </div>

                  <form className="navbar-form navbar-right" role="search">
                    <div className="input-group event-search green">
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Search by email"
                        value={searchString}
                        onChange={e => setSearchString(e.target.value)}
                      />
                      <span className="input-group-btn">
                        <button
                          className="btn btn-default btn-search"
                          type="submit"
                          onClick={e => {
                            e.preventDefault();
                            setSearch(searchString);
                          }}
                        >
                          <span className="icon icon-search" />
                        </button>
                      </span>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="panel-body">
              <DBBody
                data={rows}
                progressPending={pending}
                maxResultCount={maxResultCount}
                setMaxResultCount={setMaxResultCount}
                currentPage={currentPage}
                totalRows={totalRows}
                handlePageChange={handlePageChange}
                handleSort={setSortString}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DBPage;
